import { css } from '@emotion/core';

const styles = {
    container: css({
        maxWidth: '900px',
        margin: '0 auto',
        padding: '20px'
    }),
    section: css({
        backgroundColor: '#fff',
        border: '1px solid #ddd',
        // borderRadius: '8px',
        marginBottom: '20px',
        overflow: 'hidden'
    }),
    sectionHeader: css({
        backgroundColor: '#492865',
        color: '#fff',
        padding: '15px 20px',
        fontSize: '18px',
        fontWeight: 'bold'
    }),
    sectionContent: css({
        padding: '20px'
    }),
    row: css({
        display: 'flex',
        alignItems: 'center',
        padding: '10px 0',
        borderBottom: '1px solid #eee',
        '&:last-child': {
            borderBottom: 'none'
        }
    }),
    label: css({
        fontWeight: 'bold',
        color: '#666',
        width: '150px',
        flexShrink: 0
    }),
    value: css({
        flex: 1,
        color: '#333'
    }),
    avatarSection: css({
        display: 'flex',
        alignItems: 'center',
        gap: '20px',
        marginBottom: '20px'
    }),
    avatar: css({
        width: '100px !important',
        height: '100px !important',
        borderRadius: '50%',
        objectFit: 'cover',
        border: '2px solid #492865',
        backgroundColor: '#f5f5f5'
    }),
    avatarPlaceholder: css({
        width: '100px !important',
        height: '100px !important',
        borderRadius: '50%',
        backgroundColor: '#492865',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '36px',
        fontWeight: 'bold'
    }),
    uploadButton: css({
        backgroundColor: '#6c757d',
        color: '#fff',
        border: 'none',
        padding: '8px 16px',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '14px',
        '&:hover': {
            backgroundColor: '#5a6268'
        },
        '&:disabled': {
            backgroundColor: '#ccc',
            cursor: 'not-allowed'
        }
    }),
    formGroup: css({
        marginBottom: '15px',
        'label': {
            display: 'block',
            marginBottom: '5px',
            fontWeight: 'bold',
            color: '#333'
        },
        'input': {
            width: '100%',
            padding: '10px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            fontSize: '14px'
        }
    }),
    formRow: css({
        display: 'flex',
        gap: '20px',
        '@media (max-width: 600px)': {
            flexDirection: 'column'
        }
    }),
    formCol: css({
        flex: 1
    }),
    buttonGroup: css({
        display: 'flex',
        gap: '10px',
        marginTop: '20px'
    }),
    primaryButton: css({
        backgroundColor: '#492865',
        color: '#fff',
        border: 'none',
        padding: '12px 25px',
        borderRadius: '4px',
        cursor: 'pointer',
        fontWeight: 'bold',
        '&:hover': {
            backgroundColor: '#c41a1c'
        },
        '&:disabled': {
            backgroundColor: '#ccc',
            cursor: 'not-allowed'
        }
    }),
    secondaryButton: css({
        backgroundColor: '#c41a1c',
        color: '#fff',
        border: 'none',
        padding: '12px 25px',
        borderRadius: '4px',
        cursor: 'pointer',
        fontWeight: 'bold',
        textDecoration: 'none',
        display: 'inline-block',
        '&:hover': {
            backgroundColor: '#492865',
            color: '#fff',
            textDecoration: 'none'
        }
    }),
    successMessage: css({
        color: '#28a745',
        backgroundColor: '#d4edda',
        padding: '10px 15px',
        borderRadius: '4px',
        marginBottom: '15px'
    }),
    errorMessage: css({
        color: '#dc3545',
        backgroundColor: '#f8d7da',
        padding: '10px 15px',
        borderRadius: '4px',
        marginBottom: '15px'
    }),
    loading: css({
        textAlign: 'center',
        padding: '40px',
        color: '#666'
    }),
    loginPrompt: css({
        textAlign: 'center',
        padding: '40px',
        'a': {
            color: '#e21d20',
            fontWeight: 'bold'
        }
    }),
    historyTimeline: css({
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        padding: '15px 0'
    }),
    timelineDot: css({
        width: '12px',
        height: '12px',
        borderRadius: '50%',
        backgroundColor: '#492865'
    }),
    timelineLine: css({
        flex: 1,
        height: '2px',
        backgroundColor: '#492865'
    }),
    timelineLabel: css({
        fontSize: '14px',
        color: '#666'
    })
};

export default styles;

